import { render, staticRenderFns } from "./VenueDetailsPage.vue?vue&type=template&id=32f0adf6&scoped=true"
import script from "./VenueDetailsPage.vue?vue&type=script&lang=ts"
export * from "./VenueDetailsPage.vue?vue&type=script&lang=ts"
import style0 from "./VenueDetailsPage.vue?vue&type=style&index=0&id=32f0adf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f0adf6",
  null
  
)

export default component.exports